/**
 * DesktopIcon/index.js
 * desc: desktop icon
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const DesktopIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="desktop icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.desktop.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 22 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 0h18c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2h-7l2 3v1H7v-1l2-3H2c-1.1 0-2-.9-2-2V2C0 .9.9 0 2 0zm0 12h18V2H2v10z" /></svg>
    </IconButton>
);


export default DesktopIcon;
